import { types as t, } from 'mobx-state-tree';

const PropertyItem = t.custom({
    name: "propertyItem",

    fromSnapshot(value) {
        

        return value;
    },
    toSnapshot(value) {
        //const result = [];
        
        //for (let key of Object.keys(value)) {
        //    result.push({ key: key, value: value[key] });
        //}
        

        return value;
    },
    isTargetType(v) {
        return true; //return v instanceof CustomDate
    },
    getValidationMessage(v) {
        try {
            // tslint:disable-next-line: no-unused-expression
            //new CustomDate(v)
            return ""
        } catch (e) {
            return e.message;
        }
    }
});

export default PropertyItem;